import { useEffect, useState, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import apiClient from '../services/apiClient';

const SkillsCoachRedirect: FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const performSSO = async () => {
            try {
                const skillsCoachUrl = import.meta.env.VITE_SKILLS_COACH_FRONTEND_URL || 'http://localhost:3005';

                // Call SSO exchange endpoint
                const response = await apiClient.post('/api/v1/auth/sso/exchange/', {
                    service: 'skills-coach'
                });

                const { token } = response.data;

                // Redirect to Skills Coach with token
                window.location.href = `${skillsCoachUrl}/sso/callback?token=${token}`;
            } catch (err: any) {
                console.error('SSO Exchange failed:', err);
                setError(err.response?.data?.error || 'Failed to authenticate with Skills Coach');
            }
        };

        performSSO();
    }, [navigate]);

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 3 }}>
                <Alert severity="error" sx={{ maxWidth: 600 }}>
                    <Typography variant="h6" gutterBottom>Authentication Error</Typography>
                    <Typography>{error}</Typography>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Please ensure you have an active Skills Coach subscription.
                    </Typography>
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 3 }}>
                Redirecting to Skills Coach...
            </Typography>
        </Box>
    );
};

export default SkillsCoachRedirect;
